// extracted by mini-css-extract-plugin
module.exports = {"container":"MultipleImageInput_container__9tgEj","label":"MultipleImageInput_label__f9UkA","images":"MultipleImageInput_images__20JEx"};